import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ProtectedRoute from "./ProtectedRoute";

// 🏢 Pages (Import Only Once)
import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPageAdmin";
import ResetPasswordPageUser from "./pages/ResetPasswordPageUser";
import SignInPage from "./pages/SignInPage";

// 📌 Super Admin Pages
import CompaniesListPage from "./pages/CompaniesListPage";
import DashBoardSuperAdmin from "./pages/DashBoardSuperAdmin";
import EnquiryFormPage from "./pages/EnquiryFormPage";
import TermsPolicy from "./components/TermsPolicy";
import PrivacyPolicy from "./components/PrivacyPolicy";
import HelpSupportPage from "./pages/HelpSupportPage";
import UserDetailsPage from "./pages/UserDetailsPage";

// 🔥 Define Routes in an Array (Easier to Modify)
const routes = [
  { path: "/super-sign-in", element: <SignInPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password/:token", element: <ResetPasswordPage /> },
  { path: "/reset-password-user/:token", element: <ResetPasswordPageUser /> },
  { path: "/terms", element: <TermsPolicy /> },
  { path: "/privacy", element: <PrivacyPolicy /> },

  // Super Admin Routes
  {
    path: "/",
    element: <DashBoardSuperAdmin />,
    role: "super_admin",
  },
  {
    path: "/companies-list",
    element: <CompaniesListPage />,
    role: "super_admin",
  },
  {
    path: "/enquiry",
    element: <EnquiryFormPage />,
    role: "super_admin",
  },
  {
    path: "/help-support",
    element: <HelpSupportPage />,
    role: "super_admin",
  },
  {
    path: "/user-details/:id/:cid",
    element: <UserDetailsPage />,
    role: "super_admin",
  },
  // Catch-All 404 Page
  { path: "*", element: <ErrorPage /> },
];

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        {routes.map(({ path, element, role }) =>
          role ? (
            <Route
              key={path}
              exact
              path={path}
              element={<ProtectedRoute element={element} role={role} />}
            />
          ) : (
            <Route key={path} exact path={path} element={element} />
          )
        )}

        {/* Default Route (Redirect to sign-in if not found) */}
        <Route path="/" element={<Navigate to="/super-sign-in" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
